module.exports = __webpack_public_path__ + "static/img/FullBodyXRAY3.4c01076f.jpg";